import React from "react";

const Main = () => <>"Main page"</>;

export default Main;
